import {
  TypedUseSelectorHook,
  shallowEqual,
  useDispatch,
  useSelector
} from 'react-redux'
import { OriginalRootState } from './rootReducer'
import type { AppDispatch } from './store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<OriginalRootState> =
  useSelector

/**
 * Convenience wrapper on useSelector that uses shallowEqual as the default
 * equalityFn argument passed to useSelector
 */
export const useShallowEqualSelector: TypedUseSelectorHook<
  OriginalRootState
> = (state, equalityFn = shallowEqual) => useSelector(state, equalityFn)
